import { REGEX } from 'src/constants';
import { INTERNAL_DOMAINS } from 'src/constants/URL';

export const arrayToString = (arr: any[], lang = 'id') => {
  let string = arr.join(', ');
  const lastComma = string.lastIndexOf(',');
  let conjunction = null;
  switch (lang) {
    case 'en':
      conjunction = 'and';
      break;
    default:
      conjunction = 'dan';
      break;
  }
  string = `${string.substring(0, lastComma)}, ${conjunction}${string.substring(
    lastComma + 1,
  )}`;
  return string;
};

export const countdownString = (params: {
  hours: number;
  minutes: number;
  seconds: number;
}) => {
  const { hours, minutes, seconds } = params;
  const h = `${hours}`.padStart(2, '0');
  const m = `${minutes}`.padStart(2, '0');
  const s = `${seconds}`.padStart(2, '0');
  return `${h}:${m}:${s}`;
};

export const sanitizeSpace = (data: string) => {
  data = data.replace(/\s+/g, ' ').trim();
  return data;
};

export const removeSpace = (data: string) => {
  data = data.replace(/\s+/g, '');
  return data;
};

export const isEmailNotContainsPhoneNumber = (email?: string | null) => {
  if (!email) {
    return true;
  }
  const matchesPhoneNumberRegex = REGEX.PHONE_NUMBER.test(email.split('@')[0]);

  // Return false if it matches the phone number regex, indicating it's not a valid email
  return !matchesPhoneNumberRegex;
};

export const phoneNumberWithoutCountryCode = (phoneNumber: string) => {
  return phoneNumber.replace(/^0|\+?62/, '');
};

export const emailSeparator = ';';

export const isValidUuidV4 = (uuid: string) => {
  const regex =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return uuid.match(regex);
};

export const isInternalURL = (url: string) => {
  const { hostname } = new URL(url);
  return INTERNAL_DOMAINS.includes(hostname);
};
